/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const ArrowUp = props => (
  <svg viewBox="0 0 9.095 5.443" width="1em" height="1em" {...props}>
    <path
      d="M.143 4.084a.424.424 0 00.003.621l.654.619c.18.172.471.17.65-.003l3.089-3.007 3.13 3.009c.182.17.474.17.653-.003l.649-.623a.427.427 0 00-.002-.622L4.856.135a.478.478 0 00-.652.003L.147 4.083z"
      fill="#5d6164"
    />
  </svg>
);
export default extendIcon(ArrowUp);
